import * as React from "react";

const CustomArrowRightIcon: React.FC = () => {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M4.64592 1.6475C4.69236 1.60094 4.74754 1.564 4.80828 1.53879C4.86903 1.51359 4.93415 1.50061 4.99992 1.50061C5.06568 1.50061 5.13081 1.51359 5.19155 1.53879C5.2523 1.564 5.30747 1.60094 5.35392 1.6475L11.3539 7.6475C11.4005 7.69395 11.4374 7.74913 11.4626 7.80987C11.4878 7.87062 11.5008 7.93574 11.5008 8.0015C11.5008 8.06727 11.4878 8.13239 11.4626 8.19314C11.4374 8.25388 11.4005 8.30906 11.3539 8.3555L5.35392 14.3555C5.26003 14.4494 5.13269 14.5021 4.99992 14.5021C4.86714 14.5021 4.7398 14.4494 4.64592 14.3555C4.55203 14.2616 4.49929 14.1343 4.49929 14.0015C4.49929 13.8687 4.55203 13.7414 4.64592 13.6475L10.2929 8.0015L4.64592 2.3555C4.59935 2.30906 4.56241 2.25388 4.5372 2.19314C4.512 2.13239 4.49902 2.06727 4.49902 2.0015C4.49902 1.93574 4.512 1.87062 4.5372 1.80987C4.56241 1.74913 4.59935 1.69395 4.64592 1.6475Z"
                fill="#212529"
            />
        </svg>
    );
};

export default React.memo(CustomArrowRightIcon);
